import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'nickName',
      type: 'input',
      label: '昵称',
      placeholder: '请输入昵称'
    },
    {
      field: 'realName',
      type: 'input',
      label: '真实姓名',
      placeholder: '请输入真实姓名'
    },
    {
      field: 'empNo',
      type: 'input',
      label: '员工编号',
      placeholder: '请输入员工编号'
    },
    {
      field: 'deptId',
      type: 'select',
      label: '部门',
      placeholder: '请选择用户部门'
    },
    // {
    //   field: 'enabled',
    //   type: 'select',
    //   label: '用户状态',
    //   placeholder: '请选择员工状态',
    //   options: [
    //     { title: '正常', value: '1' },
    //     { title: '禁用', value: '0' }
    //   ]
    // },
    {
      field: 'createdTime',
      type: 'datepicker',
      label: '创建时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    },
    {
      field: 'lastLoginTime',
      type: 'datepicker',
      label: '最后登录时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    },
    {
      field: 'empTag',
      type: 'select',
      label: '员工标签',
      placeholder: '请选择员工标签',
      options: [
        { title: '518', value: 0 },
        { title: '投教', value: 1 },
      ]
    }
  ]
}
